import { render } from "./SoftwareIntro.vue?vue&type=template&id=e5d705c8&scoped=true"
import script from "./SoftwareIntro.vue?vue&type=script&lang=js"
export * from "./SoftwareIntro.vue?vue&type=script&lang=js"

import "./SoftwareIntro.vue?vue&type=style&index=0&id=e5d705c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5d705c8"]])

export default __exports__